import ItemStatusDriver from './ItemStatusDriver';

type Props = {
  busy: number;
  free: number;
  onBrake: number;
  statusActive: string;
  isLoadingDrivers: boolean;
  onFilterByStatusDriver: (state: string) => void;
};

const StatusDrivers = ({
  free,
  busy,
  onBrake,
  statusActive,
  isLoadingDrivers,
  onFilterByStatusDriver
}: Props): JSX.Element => {
  return (
    <div className="gap-4 flex justify-start py-2 pl-2 pr-2">
      <ItemStatusDriver
        status="FREE"
        onFilterByStatusDriver={onFilterByStatusDriver}
        bgColor="bg-green-100 dark:bg-success-dark/10"
        isActive={statusActive === 'FREE'}
        borderColor="border-green-700 dark:border-success-dark"
        label="Libres"
        value={free}
        color="text-green-700 dark:text-success-dark"
        loadingColor="#59B9A6"
        isLoadingDrivers={isLoadingDrivers}
      />
      <ItemStatusDriver
        status="BUSY"
        onFilterByStatusDriver={onFilterByStatusDriver}
        bgColor="bg-red-100 dark:bg-danger-dark/10"
        isActive={statusActive === 'BUSY'}
        borderColor="border-red-500 dark:border-danger-dark"
        label="Ocupados"
        value={busy}
        color="text-red-500 dark:text-danger-dark"
        isLoadingDrivers={isLoadingDrivers}
        loadingColor="#E94B5C"
      />
      <ItemStatusDriver
        status="UNAVAILABLE"
        onFilterByStatusDriver={onFilterByStatusDriver}
        bgColor="bg-orange-100 dark:bg-warning-dark/10"
        isActive={statusActive === 'UNAVAILABLE'}
        borderColor="border-orange-500 dark:border-warning-dark"
        label="No disponibles"
        value={onBrake}
        color="text-orange-500 dark:text-warning-dark"
        isLoadingDrivers={isLoadingDrivers}
        loadingColor="#F39E2B"
      />
    </div>
  );
};

export default StatusDrivers;
